import cookie from 'react-cookies';
import env from '@/env';

const COOKIE_DOMAIN = env.cookie.domain;

const COOKIE_REFRESH_TOKEN = 'refreshToken';
const COOKIE_ID_TOKEN = 'id_token';
const COOKIE_ACCESS_TOKEN = 'access_token';
const SOCIAL_ACCESS_TOKEN = 'social_user';
const LINKEDIN_CALLBACK = 'linkedin_callback';
const ASSET_HISTORY = 'asset_history';
const ORGANISATION_TOKEN = 'org-token';

const setCookie = (name: string, value: string) =>
  cookie.save(name, value, { path: '/', domain: COOKIE_DOMAIN });

const getCookie = (name: string) => cookie.load(name);

const removeCookie = (name: string) => cookie.remove(name, { path: '/', domain: COOKIE_DOMAIN });

class AuthHelpers {
  storeIdToken = (idToken: string) => setCookie(COOKIE_ID_TOKEN, idToken);

  getIdToken = () => getCookie(COOKIE_ID_TOKEN);

  storeSocialToken = (socialToken: string) => setCookie(SOCIAL_ACCESS_TOKEN, socialToken);

  getSocialToken = () => getCookie(SOCIAL_ACCESS_TOKEN);

  clearSocialToken = () => {
    removeCookie(SOCIAL_ACCESS_TOKEN);
  };

  storeAssetHistory = (assetHistory: string) => setCookie(ASSET_HISTORY, assetHistory);

  getAssetHistory = () => getCookie(ASSET_HISTORY);

  clearAssetHistory = () => {
    removeCookie(ASSET_HISTORY);
  };

  storeLinkedInCallback = (linkedinCB: string) => setCookie(LINKEDIN_CALLBACK, linkedinCB);

  getLinkedInCallback = () => getCookie(LINKEDIN_CALLBACK);

  clearLinkedInCallback = () => {
    removeCookie(LINKEDIN_CALLBACK);
  };

  storeRefreshToken = (refreshToken: string) => setCookie(COOKIE_REFRESH_TOKEN, refreshToken);

  getRefreshToken = () => getCookie(COOKIE_REFRESH_TOKEN);

  getAccessToken = () => getCookie(COOKIE_ACCESS_TOKEN);

  storeAccessToken = (accessToken: string) => setCookie(COOKIE_ACCESS_TOKEN, accessToken);

  getOrgToken = () => getCookie(ORGANISATION_TOKEN);

  storeOrgToken = (orgToken: string) => setCookie(ORGANISATION_TOKEN, orgToken);

  clearTokens = () => {
    removeCookie(COOKIE_REFRESH_TOKEN);
    removeCookie(COOKIE_ID_TOKEN);
    removeCookie(COOKIE_ACCESS_TOKEN);
    removeCookie(ORGANISATION_TOKEN);
  };
}

const instance = new AuthHelpers();
export default instance;
